import { useQuery } from "@tanstack/react-query";
import { calcRecordsApi } from "../../../modules/calculator/records/api";
import { CalcRecordFilterPageRequest, CalcRecordRequestResponse } from "../../../modules/calculator/records/types";
import { toCalcRecordFilterApiRequest } from "../../../modules/calculator/records/utils";
import { UUID } from "../../../typings/global";

export const CALC_RECORDS_QUERY_KEYS = {
  filterCalcRecords: (payload?: CalcRecordFilterPageRequest) =>
    payload ? ["filterCalcRecords", payload] : ["filterCalcRecords"],
  getCalcRecordRequestResponse: (id: UUID) => ["getCalcRecordRequestResponse", id],
  getCalcRecordWebservicesLogs: (id: UUID) => ["getCalcRecordWebservicesLogs", id],
  getCalcRecordStackTracesLogs: (id: UUID) => ["getCalcRecordStackTracesLogs", id],
};

export const useFilterCalcRecords = (payload: CalcRecordFilterPageRequest) => {
  return useQuery({
    queryKey: CALC_RECORDS_QUERY_KEYS.filterCalcRecords(payload),
    queryFn: async () => {
      const { data } = await calcRecordsApi.filterCalcRecords(toCalcRecordFilterApiRequest(payload));

      return data;
    },
  });
};

export const useGetCalcRecordRequestResponse = <T extends CalcRecordRequestResponse = CalcRecordRequestResponse>(
  id: UUID,
) => {
  return useQuery({
    queryKey: CALC_RECORDS_QUERY_KEYS.getCalcRecordRequestResponse(id),
    queryFn: async () => {
      const { data } = await calcRecordsApi.getCalcRecordRequestResponse<T>({ id });

      return data;
    },
    enabled: !!id,
    retry: 1,
  });
};

export const useGetCalcRecordWebservicesLogs = (id: UUID) => {
  return useQuery({
    queryKey: CALC_RECORDS_QUERY_KEYS.getCalcRecordWebservicesLogs(id),
    queryFn: async () => {
      const { data } = await calcRecordsApi.getCalcRecordWebservicesLogs({ id });

      return data;
    },
    enabled: !!id,
  });
};

export const useGetCalcRecordStackTracesLogs = (id: UUID) => {
  return useQuery({
    queryKey: CALC_RECORDS_QUERY_KEYS.getCalcRecordStackTracesLogs(id),
    queryFn: async () => {
      const { data } = await calcRecordsApi.getCalcRecordStackTracesLogs({ id });

      return data;
    },
    enabled: !!id,
  });
};
